var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.switchItem === 'news')?_c('div',[_c('div',[_c('d-select',{attrs:{"items":_vm.itemsMobile,"static-label":"Выберите сегмент"},model:{value:(_vm.activity),callback:function ($$v) {_vm.activity=$$v},expression:"activity"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }